export default __webpack_public_path__ + "16f9e653001d79974fa2474fa180f327.png";